/**
 * Behaves exactly like a React Fragment aka "<>...</>".
 * 
 * Usage: 
 * import Fragment from "fragment";
 *
 * render() {
     return (
        <Fragment>
            <div>First element...</div>
            <div>Second element...</div>
            <div>Another element...</div>
        </Fragment>
     );
   }
*/
export default (_props: any, children: any) => [...children];
